<template>
  <div class="bankCardManage">
    <div class="settingwarp">
      <header>
        <div class="g-header" style="background: rgb(14, 21, 48)">
          <div class="left" @click="changego">
            <van-icon name="arrow-left" color="#fff" size="20px" />
          </div>
          <div class="middle fs-18">
            {{ $t('yinhangkaguanli') }}
          </div>
          <div class="right">
            <div class="bg-icon bg-icon-setting"></div>
          </div>
        </div>
        <div class="blockHeight"></div>
      </header>

      <div class="g-content">
        <!-- ✅ 仅保留银行卡 -->
        <ul class="card-list" v-if="bank">
          <li class="card-item">
            <p>{{ bank.acc_bank }}</p>
            <p class="cardNo">{{ bank.acc_name }}</p>
          </li>
        </ul>

        <!-- ✅ 已取消：虚拟钱包列表 -->
        <!--
        <ul class="card-list" v-if="false && bank">
          <li class="card-item">
            <p>{{bank.acc}}</p>
            <p class="cardNo">{{bank.acc_name}}</p>
          </li>
        </ul>
        -->

        <!-- 添加银行卡 -->
        <div class="add-card-btn">
          <div class="div" @click="changeAddcard()">
            <i></i>
            <span>{{ $t('tianjiayinhangka') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from "@/api/user";

export default {
  name: "BankCardManage",
  components: {},
  data() {
    return {
      // ✅ 强制只走银行卡
      type: 0,
      bank: null,
    };
  },
  methods: {
    changeAddcard() {
      // ✅ 只允许添加银行卡
      this.$router.push({ path: "/addBankCard" });
    },
    changego() {
      this.$router.go(-1);
    },
  },
  created() {
    // ✅ 忽略路由 query.type，强制请求银行卡信息
    userApi.payInfo(0).then((data) => {
      this.bank = data.data;
    });
  },
};
</script>

<style lang="less" scoped>
.settingwarp {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.card-list {
  padding: 0.3rem;
  text-align: left;
}
.card-item {
  border-radius: 0.06rem;
  padding: 0.3rem;
  background: #1a243f;
  font-size: 0.38rem;
}
.cardNo {
  margin-top: 0.1rem;
}
</style>
